import { searchInputStyles } from "@insite/content-library/Widgets/Header/SearchInput";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

searchInputStyles.autocompleteWrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        > div {
            background: #fff !important;
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        flex-direction: column-reverse;
                    `,
                ],
                "max",
            )}
    `,
};
